<template>
  <div>
    <v-container class="pa-4">
      <!-- Tab All-->
      <v-tabs
        slider-color="transparent"
        color="transparent"
        v-if="contentTab.length > 0"
      >
        <v-tab
          class="headerTab grey--text"
          active-class="black--text"
          v-for="item in titleTab"
          :key="item"
          >{{ item }}</v-tab
        >
        <v-tabs-items v-model="selected">
          <v-tab-item v-for="content in contentTab" :key="content">
            <!-- @click="selected = content" -->
            <v-card class="elevation-3" style="border-radius: 10px">
              <v-card-text>
                <component :is="content"></component>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <br />
      <!-- Tab Hotel Service -->
      <v-tabs
        v-model="active"
        slider-color="transparent"
        color="transparent"
        v-if="
          permission.report.rider &&
          Object.keys(permission.report.rider).length > 0
        "
      >
        <v-tab class="headerTab">Hotel Service</v-tab>
        <v-tab-item>
          <v-card class="elevation-3" style="border-radius: 10px">
            <v-card-text>
              <DashboardHotelService />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <br />
      <!-- Tab Rider -->
      <v-tabs
        v-model="active"
        slider-color="transparent"
        color="transparent"
        v-if="
          permission.report.rider &&
          Object.keys(permission.report.rider).length > 0
        "
      >
        <v-tab class="headerTab">Rider</v-tab>
        <v-tab-item>
          <v-card class="elevation-3" style="border-radius: 10px">
            <v-card-text>
              <DashboardRider />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <br />
      <!-- Tab Order Receipt -->
      <v-tabs
        v-model="active"
        slider-color="transparent"
        color="transparent"
        v-if="
          permission.report.order_receipt &&
          Object.keys(permission.report.order_receipt).length > 0
        "
      >
        <v-tab class="headerTab">Order Reciept</v-tab>
        <v-tab-item>
          <v-card class="elevation-3" style="border-radius: 10px">
            <v-card-text>
              <DashboardReceipt />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import DashboardAll from "@/components/back-office/Report/DashboardAll";
import DashboardFoodFree from "@/components/back-office/Report/DashboardFoodFree";
import DashboardRider from "@/components/back-office/Report/DashboardRider";
import DashboardMessen from "@/components/back-office/Report/DashboardMessen";
import DashboardReceipt from "@/components/back-office/Report/DashboardReceipt";
import DashboardHotelService from "@/components/back-office/Report/DashboardHotelService";
import { mapState } from "vuex";
export default {
  components: {
    DashboardAll,
    DashboardFoodFree,
    DashboardRider,
    DashboardMessen,
    DashboardReceipt,
    DashboardHotelService,
  },

  data() {
    return {
      active: null,
      date: "09-07-2019",
      currentTab: "DashboardAll",
      selected: "DashboardAll",
    };
  },

  methods: {
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
  },

  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    titleTab() {
      let tab_list = [];
      if (
        this.permission.report.summary &&
        Object.keys(this.permission.report.summary).length > 0
      ) {
        tab_list.push("All");
      }
      if (
        this.permission.report.free_food &&
        Object.keys(this.permission.report.free_food).length > 0
      ) {
        tab_list.push("Food&Free delivery");
      }
      if (
        this.permission.report.messenger &&
        Object.keys(this.permission.report.messenger).length > 0
      ) {
        tab_list.push("Messenger");
      }
      return tab_list;
    },
    contentTab() {
      let tab_list = [];
      if (
        this.permission.report.summary &&
        Object.keys(this.permission.report.summary).length > 0
      ) {
        tab_list.push("DashboardAll");
      }
      if (
        this.permission.report.free_food &&
        Object.keys(this.permission.report.free_food).length > 0
      ) {
        tab_list.push("DashboardFoodFree");
      }
      if (
        this.permission.report.messenger &&
        Object.keys(this.permission.report.messenger).length > 0
      ) {
        tab_list.push("DashboardMessen");
      }
      if (tab_list.length > 0) {
        this.currentTab = tab_list[0];
        this.selected = tab_list[0];
      }
      return tab_list;
    },
  },

  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.headerTab {
  font-size: 18px;
}
.report-title {
  font-size: 18px;
  font-weight: bold;
}
.report-card {
  border-radius: 10px;
}
.date-today {
  text-align: right;
  position: absolute;
  right: 0;
  margin: 15px 10px 0 0;
}
</style>
